export const faqs = [
  {
    q: "瓜集社里的合集和普通热搜有什么不同？",
    a: "热搜是单条信息，合集是把同一个话题从头到尾的相关内容整理成一条专题。你在瓜集社看到的是一个完整目录，而不是零散的片段。",
  },
  {
    q: "独家吃瓜盘点多久更新一次？",
    a: "网络热议类专题每周固定更新，影视、音乐、综艺类专题通常在事件收尾后统一整理，保证一条专题看完整段过程。",
  },
  {
    q: "专题目录里的内容是怎么整理的？",
    a: "我们按时间顺序梳理公开讨论的内容，标注每个看点的对应时间，只做归纳不做主观排名，方便你自己判断。",
  },
  {
    q: "可以在手机上浏览合集吗？",
    a: "可以。站点采用响应式设计，手机、平板和电脑都能正常查看，导航在移动端会自动收起为菜单。",
  },
  {
    q: "发现专题里的信息有误怎么办？",
    a: "欢迎通过页脚的邮箱联系我们，说明具体是哪一条专题、哪一段内容，我们核实后会尽快修订。",
  },
];